import { isAfter, isBefore, UTCDate } from '@/utils/dates';
import { Row } from '@tanstack/react-table';
import { InvoiceEvidenceView } from '../../../../../types/entity-types';

export const sortDueDate = (rowA: Row<InvoiceEvidenceView>, rowB: Row<InvoiceEvidenceView>, columnId: string) => {
  const dueDateA = rowA.getValue<string>(columnId);
  const dueDateB = rowB.getValue<string>(columnId);

  if (dueDateA === 'Unknown' && dueDateB !== 'Unknown') {
    return -1;
  }

  if (dueDateB === 'Unknown' && dueDateA !== 'Unknown') {
    return 1;
  }

  if (dueDateA === 'Unknown' && dueDateB === 'Unknown') {
    return 0;
  }

  if (isBefore(new UTCDate(dueDateA), new UTCDate(dueDateB))) {
    return -1;
  }
  if (isAfter(new UTCDate(dueDateA), new UTCDate(dueDateB))) {
    return 1;
  }

  return 0;
};
